import Component from "@base/Component.js";
import GearPile from "./GearPile.js";
import t from "@/services/translationService.js";

/**
 * Showcase ("Gear") page: page-intro header + the gear pile. View-only —
 * gear is managed in the Cockpit (#/cockpit/gear).
 * props: { items: ShowcaseObject[], lang, admin, onOpen }
 */
export default class ShowcasePage extends Component {
  render() {
    return `
      <article class="showcase-page">
        <header class="page-intro">
          <h1 class="page-intro__title">${t.t("showcase.title")}</h1>
          <div class="page-intro__rule"></div>
        </header>
        <div class="gear-pile-slot"></div>
      </article>`;
  }

  async onMounted() {
    this.gearPile = await this.mountChild(
      GearPile,
      {
        items: this.props.items,
        lang: this.props.lang,
        admin: this.props.admin,
        onOpen: this.props.onOpen,
      },
      this.$(".gear-pile-slot")
    );
  }

  /** Refresh the pile's items in place (after an admin add/edit/delete) - see GearPile#updateItems. */
  refreshItems(items) {
    this.props.items = items;
    this.gearPile?.updateItems(items);
  }
}
